package org.ssoft.common.type

interface Mask {
    val mask: Int
    fun toInt(): Int = mask

    infix fun match(mask: Int): Boolean = this.mask == mask

    infix fun notMatch(mask: Int): Boolean = !match(mask)

    companion object {
        operator fun <T : Mask> get(mask: Int, items: List<T>) = items.firstOrNull { it match mask }
    }
}